import type { ActivityRow, FieldChangeRow, TableRowChange } from '../../core';

type TableRow = Extract<ActivityRow, { kind: 'table' }>;

const isTableRow = (row: ActivityRow): row is TableRow => row.kind === 'table';

// Cells of one table row arrive as separate entries — one per edited cell.
const mergeTableRows = (tableRows: TableRowChange[]): TableRowChange[] => {
  const cellsByRowId = new Map<number, FieldChangeRow[]>();
  tableRows.forEach(({ rowId, cells }) => {
    cellsByRowId.set(rowId, (cellsByRowId.get(rowId) ?? []).concat(cells));
  });
  return Array.from(cellsByRowId, ([rowId, cells]) => ({ rowId, cells }));
};

// Header fields first, then one row per table.
export const combineFieldRows = (rows: ActivityRow[]): ActivityRow[] => {
  const tables = new Map<string, TableRow>();
  rows.filter(isTableRow).forEach(table => {
    const existing = tables.get(table.schemaId);
    tables.set(
      table.schemaId,
      existing ? { ...existing, rows: existing.rows.concat(table.rows) } : table
    );
  });

  const headerFields: ActivityRow[] = rows.filter(row => !isTableRow(row));
  const mergedTables: ActivityRow[] = Array.from(tables.values(), table => ({
    ...table,
    rows: mergeTableRows(table.rows),
  }));

  return headerFields.concat(mergedTables);
};
